import { Identifier, useTranslate } from 'react-admin';
import { SecurityInventoryItem } from '@x-guard/xgac-types/xgac';

export const SelectAllButton = (props: {
  selectedIds: Identifier[]; setSelectedIds: React.Dispatch<React.SetStateAction<Identifier[]>>; items: SecurityInventoryItem[];
}) => {

  const translate = useTranslate();
  const allSelected = (props.selectedIds.length === props.items.length) && (props.items.length > 0);

  return (
    <>
      {allSelected ? (
        <button type="button" className="select-all-button deselect-all-button" onClick={() => {

          props.setSelectedIds([]);

        }}>
          <span>{translate('general.text.deselect_all')}</span>
        </button>
      ) : (
        <>
          <button type="button" className="select-all-button" onClick={() => {

            props.setSelectedIds(props.items.map((item) => item._id));

          }}>
            <span>{translate('general.text.select_all')}</span>
          </button>
        </>
      )}
    </>
  );

};
